// extracted by mini-css-extract-plugin
export default {"button":"GoToDetailsTab_button__-S8ut"};